var map = {
	"./bounce/blocks": 2433,
	"./calc/blocks": 2434,
	"./craft/agent/blocks": 2436,
	"./craft/code-connection/blocks": 2437,
	"./craft/designer/blocks": 2305,
	"./craft/simple/blocks": 2435,
	"./dance/blocks": 1915,
	"./eval/blocks": 2439,
	"./flappy/blocks": 2440,
	"./jigsaw/blocks": 2446,
	"./maze/blocks": 2451,
	"./p5lab/spritelab/blocks": 1481,
	"./sites/studio/pages/blocks": 2463,
	"./studio/blocks": 2313,
	"./turtle/blocks": 2459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2895;